/* ============================================================
   Modulo: Back to Top · Progress  (prefix: btp)
   Floating button that tracks window scroll. The ring fills as the
   page scrolls (pathLength=1 → stroke-dashoffset 1→0); the button
   fades in past a merchant-set threshold; click returns to top.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var buttons = [];
  var listening = false;

  /* Size the ring from the rendered button so it hugs the edge at any
     size / thickness. viewBox = px size → 1 user unit = 1px. */
  function layout(btn) {
    var ring = btn.querySelector('.modulo-btp__ring');
    if (!ring) return;
    var size = btn.getBoundingClientRect().width;
    if (!size) return;
    var thick = parseFloat(window.getComputedStyle(btn).getPropertyValue('--modulo-btp-ring-thick')) || 3.5;
    var r = (size - thick) / 2 - 1;
    if (r < 1) r = 1;
    ring.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
    var circles = ring.querySelectorAll('circle');
    for (var i = 0; i < circles.length; i++) {
      circles[i].setAttribute('cx', size / 2);
      circles[i].setAttribute('cy', size / 2);
      circles[i].setAttribute('r', r);
    }
  }

  function progress() {
    var de = document.documentElement;
    var max = de.scrollHeight - de.clientHeight;
    if (max <= 0) return 0;
    var p = (window.pageYOffset || de.scrollTop || 0) / max;
    return p < 0 ? 0 : p > 1 ? 1 : p;
  }

  function prune() {
    for (var i = buttons.length - 1; i >= 0; i--) {
      if (!buttons[i].isConnected) buttons.splice(i, 1);
    }
  }

  function render() {
    var p = progress();
    for (var i = buttons.length - 1; i >= 0; i--) {
      var btn = buttons[i];
      if (!btn.isConnected) { buttons.splice(i, 1); continue; }
      var fill = btn.querySelector('.modulo-btp__fill');
      if (fill) fill.style.strokeDashoffset = String(1 - p);
      var threshold = btn.__btpThreshold || 0; // parsed once in init(), not per frame
      if (p >= threshold && p > 0) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { render(); ticking = false; });
  }

  var resizeT;
  function onResize() {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      prune();
      for (var i = 0; i < buttons.length; i++) layout(buttons[i]);
      render();
    }, 100);
  }

  function clickTop() {
    var smooth = this.getAttribute('data-smooth') !== 'false' && !REDUCE;
    try {
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }

  function init(btn) {
    if (btn.__btpInit) return;
    btn.__btpInit = true;
    btn.__btpThreshold = (parseFloat(btn.getAttribute('data-threshold')) || 0) / 100;
    buttons.push(btn);
    btn.addEventListener('click', clickTop);
    layout(btn);
  }

  function scan(root) {
    var els = (root || document).querySelectorAll('[data-modulo-btp]');
    for (var i = 0; i < els.length; i++) init(els[i]);
    if (!buttons.length) return;
    render();
    if (!listening) {
      listening = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);
    }
  }

  function bootstrap() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Theme editor: re-scan + re-measure when the section re-renders. */
  document.addEventListener('shopify:section:load', function (e) {
    prune();
    scan(e.target || document);
    for (var i = 0; i < buttons.length; i++) layout(buttons[i]);
    render();
  });
})();
